import { ChildType, addKidsI, ChildLookUp, toyInterfaceI, addressI } from './Interface';
export enum ChildrenType {
	LOADING_KIDS = 'LOADING/KIDS',
	LOADING_KIDS_FAIL = 'LOADING/KIDS/FAIL',
	LOAD_ALL_KIDS = 'LOAD?ALL?KIDS',
	ADD_KID = 'ADD/KID',
	UPDATE_CURRENT_KID = 'UPDATE/CURRENT/KID',
	REMOVE_KID = 'REMOVE_KID',
	UPDATE_KIDS = 'UPDATE_KIDS',
	LOOKUP_KID = 'LOOKUP_KID',
	TOY_INSTANCES = 'TOY_INSTANCES',
	SHIP_TOY = 'SHIP_TOY',
	NEXT_BOX = 'NEXT_BOX',
	CHANGE_EXPIRY_DATE = 'CHANGE_EXPIRY_DATE',
	LOAD_ADDRESS_KID = 'LOAD_ADDRESS_KID',
}
interface child {
	type: typeof ChildrenType.LOAD_ALL_KIDS;
	payload: {
		data: ChildType[];
	};
}
interface addKid {
	type: typeof ChildrenType.ADD_KID;
	payload: {
		message: addKidsI;
	};
}
interface updatemyKid {
	type: typeof ChildrenType.UPDATE_KIDS;
	payload: {
		message: addKidsI;
	};
}
interface LOAD_KIDS {
	type: typeof ChildrenType.LOADING_KIDS;
}
interface LOAD_KIDS_FAIL {
	type: typeof ChildrenType.LOADING_KIDS_FAIL;
	payload: {
		errors: any | undefined;
	};
}
interface RemoveKid {
	type: typeof ChildrenType.REMOVE_KID;
}
interface LookUpKid {
	type: typeof ChildrenType.LOOKUP_KID;
	payload: {
		data: ChildLookUp;
	};
}
interface LoadToyInstances {
	type: typeof ChildrenType.TOY_INSTANCES;
	payload: {
		data: toyInterfaceI[];
	};
}

interface ShipToy {
	type: typeof ChildrenType.SHIP_TOY;
}
interface nextBoxType {
	type: typeof ChildrenType.NEXT_BOX;
}
interface changeExpiryType {
	type: typeof ChildrenType.CHANGE_EXPIRY_DATE;
}
interface addressType {
	type: typeof ChildrenType.LOAD_ADDRESS_KID;
	payload: {
		data: addressI;
	};
}
export type childActionType =
	| child
	| addKid
	| LOAD_KIDS
	| LOAD_KIDS_FAIL
	| RemoveKid
	| updatemyKid
	| LookUpKid
	| LoadToyInstances
	| ShipToy
	| nextBoxType
	| changeExpiryType
	| addressType;
